import { render, staticRenderFns } from "./ClientBranchEdit.vue?vue&type=template&id=67c6f2cf&lang=pug"
import script from "./ClientBranchEdit.vue?vue&type=script&lang=js"
export * from "./ClientBranchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports